// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"a9235193","11":"5aa8d543","21":"7ee7a295","98":"9e84c1ab","215":"c02fd715","264":"4786b88f","312":"2935ead2","489":"4cd8c1a7","922":"d363980a"}[chunkId] + ".chunk.css";
};